import { module as BaseModule } from 'modujs';
import Packery from 'packery';
import imagesLoaded from 'imagesloaded';

export default class extends BaseModule {
  constructor(m) {
    super(m);
  }

  init() {
    const container = this.el;

    if (!container) return;

    const items = container.querySelectorAll('figure.wp-block-image');

    if (!items.length) return;

    // Paso 1: aplicar clases de orientación según proporción de la imagen
    items.forEach((item) => {
      const img = item.querySelector('img');
      if (!img) return;

      const classifyImage = () => {
        const { naturalWidth: w, naturalHeight: h } = img;

        if (!w || !h) return;

        item.classList.remove('ratio-1x1', 'ratio-2x1', 'ratio-1x2');

        const ratio = w / h;

        if (ratio > 1.5) {
          item.classList.add('ratio-2x1');
        } else if (ratio < 0.75) {
          item.classList.add('ratio-1x2');
        } else {
          item.classList.add('ratio-1x1');
        }
      };

      if (img.complete) {
        classifyImage();
      } else {
        img.onload = classifyImage;
      }

      item.classList.add('masonry-item');
    });

    let pckry = null;

    // Paso 2: Esperar a que todas las imágenes estén completamente cargadas antes de inicializar Packery
    imagesLoaded(container, { background: true }, () => {
      pckry = new Packery(container, {
        itemSelector: '.masonry-item',
        gutter: 0,
        percentPosition: true,
        originLeft: true,
        horizontalOrder: true,
      });

      // Layout inicial
      pckry.layout();

      // Reajuste progresivo mientras se cargan (por si alguna se carga tarde)
      imagesLoaded(container).on('progress', () => {
        pckry.layout();
      });

      // Fallback adicional
      setTimeout(() => {
        pckry.layout();
      }, 1200);
    });

    // Paso 3: Relayout en resize para mantener el responsive
    window.addEventListener('resize', () => {
      if (pckry) {
        pckry.layout();
      }
    });
  }
}
